import React, {FC, useState} from "react";
import {Dropdown, DropdownButton, FormLabel} from "react-bootstrap";

export interface Employees {
  title: string,
  value: string
}

interface DropdownEmployeesProps {
  employee: Employees,
  setEmployees: (employees: Employees) => void
}

export const DropdownEmployeesValues = [
  {title: "Choose one of the following...", value: ""},
  {title: "No collaborators", value: "no collaborators"},
  {title: "2-10 employees", value: "2-10 employees"},
  {title: "11-50 employees", value: "11-50 employees"},
  {title: "51-200 employees", value: "51-200 employees"},
  {title: "201-500 employees", value: "201-500 employees"},
  {title: "501-1,000 employees", value: "501-1,000 employees"},
  {title: "501-10,000 employees", value: "501-10,000 employees"},
  {title: "10,001+ employees", value: "10,001+ employees"},
]

const DropdownEmployees: FC<DropdownEmployeesProps> = ({employee, setEmployees}) => {
  const [message, setMessage] = useState('');

  const items = DropdownEmployeesValues.map((employee: Employees, index) => {
      return (
        <Dropdown.Item key={`dropdown-employee-${index}`} onClick={() => setEmployeesAndMessage(employee)}>
          {employee.title}
        </Dropdown.Item>
      );
    }
  );

  function setEmployeesAndMessage(employees: Employees) {
    if (employees.value === "no collaborators" || employees.value === "1-10 employees") {
      setMessage("Villa has your back! Come meet and play with other pros in public Villas. It's easy to create and invite teammates to your Metaverse");
    } else {
      setMessage('');
    }
    setEmployees(employees);
  }

  return (
    <>
      <div className="row pt-2">
        <div className="col-3 d-none d-md-block">&nbsp;</div>
        <div className="col-12 col-md-6">
          <h5><span className="orange">{message}</span></h5>
        </div>
        <div className="col-3 d-none d-md-block">&nbsp;</div>
      </div>
      <div className="row">
        <div className="col-3 d-none d-md-block">&nbsp;</div>
        <div className="col-12 col-md-6 pb-1">
          <FormLabel className="mb-0">Number of collaborators in my Metaverse *</FormLabel>
        </div>
        <div className="col-3 d-none d-md-block">&nbsp;</div>
      </div>
      <div className="row py-0">
        <div className="col-3 d-none d-md-block">&nbsp;</div>
        <div className="col-12 col-md-6">
          <div className="row">
            <div className="col">
              <Dropdown onClick={(e: any) => e.stopPropagation()}>
                <DropdownButton key="dropdown-button device" menuAlign="left" title={employee.title}>
                  {items}
                </DropdownButton>
              </Dropdown>
            </div>
          </div>
        </div>
        <div className="col-3 d-none d-md-block">&nbsp;</div>
      </div>
    </>
  );
}

export default DropdownEmployees;
